/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块
//http://dev.efashion-paris.com:3000
const sort = {
    //获取产品
    getPList(query, id) {
        let obj = {}
        for (var key in query) {
            if (query[key]) {
                obj[key] = query[key]
            }
        }
        if (!id) {
            obj.id_langue = localStorage.getItem("lang") || "fr";
            return axios.get(`${base.dev}/produits`, {params: obj});
        }
        if (id.length > 2) id = id.substr(0, 2);
        return axios.get(base.dev + '/categories/' + id + '/produits', {params: obj, timeout: 25 * 1000});
    },
    //获取详情
    getDetail(obj, id) {
        return axios.get(base.dev + '/produits/' + obj.id_produit + '?id_langue=' + id, {params: obj});
    },
    //加入购物车
    addOrder(obj) {
        return axios.post(base.dev + '/orders', obj);
    },
}

export default sort;
